export const RMS_ACCESS_REQUIREMENTS = Object.freeze({
  VIEW: Object.freeze(["rms.view", "revenue_optimizer.access"]),
  CONFIGURE: Object.freeze(["rms.configure", "access_settings"]),
  APPROVE: Object.freeze(["rms.approve"]),
  APPLY: Object.freeze(["rms.apply"]),
  ROLLBACK: Object.freeze(["rms.rollback"]),
  APPLY_MARKET_PRICES: Object.freeze(["revenue.apply_market_prices"]),
});

export function hasAnyRmsPermission(permissions, requirement) {
  return requirement.some((key) => permissions?.[key] === true);
}

export const canViewRms = (permissions) =>
  hasAnyRmsPermission(permissions, RMS_ACCESS_REQUIREMENTS.VIEW);

export const canConfigureRms = (permissions) =>
  hasAnyRmsPermission(permissions, RMS_ACCESS_REQUIREMENTS.CONFIGURE);

export const canApproveRms = (permissions) =>
  hasAnyRmsPermission(permissions, RMS_ACCESS_REQUIREMENTS.APPROVE);

export const canApplyRms = (permissions) =>
  hasAnyRmsPermission(permissions, RMS_ACCESS_REQUIREMENTS.APPLY);

export const canRollbackRms = (permissions) =>
  hasAnyRmsPermission(permissions, RMS_ACCESS_REQUIREMENTS.ROLLBACK);

export const canApplyMarketPrices = (permissions) =>
  hasAnyRmsPermission(permissions, RMS_ACCESS_REQUIREMENTS.APPLY_MARKET_PRICES);

// Operational workflow actions deliberately accept canonical permissions only.
export const canApproveRmsWorkflow = (permissions) =>
  permissions?.["rms.approve"] === true;

export const canApplyRmsWorkflow = (permissions) =>
  permissions?.["rms.apply"] === true;
